import config from 'config';
import { appsignalInstance } from '.';

const appsignalSendError = (
  action: string,
  error: Error,
  data?: Record<string, unknown>
) => {
  if (!config.appSignal?.active) return;

  appsignalInstance.sendError(error, (span) => {
    span.setAction(action);
    span.setTags({ client_id: config.hostname });

    span.setError({
      name: error.name,
      stack: error.stack,
      message: JSON.stringify({
        message: error.message,
        href: typeof window !== 'undefined' ? window.location.href : '',
        ...(data || {})
      })
    });
  });
};

export default appsignalSendError;
